var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"view notification-view"},[_c('div',{staticClass:"notification-overview"},[_c('h1',[_vm._v("Aktuelle Meldungen")]),_c('ul',_vm._l((_vm.notifications),function(item,index){return _c('notification',{key:index,attrs:{"item":item}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }